export default __webpack_public_path__ + "static/media/menu.bd18f7f6.svg";